// List of allowed emails
const ALLOWED_EMAILS = [
    'junlim3@illinois.edu',
    'alexison@usc.edu',
    'alexison.pan@gmail.com'
];

export const validateEmail = (email) => {
    if (!email) return false;
    return ALLOWED_EMAILS.includes(email.toLowerCase());
};

export const isAuthorized = (email) => {
    return validateEmail(email);
}; 